import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@mui/material";
export function Content({ children, sidebar, ...props }) {
    if (!children) {
        return null;
    }
    return (_jsxs(Grid, { container: true, columnSpacing: 2, sx: { "& + &": { mt: 0 } }, wrap: "nowrap", ...props, children: [_jsx(Grid, { item: true, sx: { maxWidth: 572, width: "100%", flex: "1 0 auto" }, children: children }), sidebar && (_jsx(Grid, { item: true, "data-content-sidebar": true, sx: { flex: "1 1 auto" }, children: sidebar }))] }));
}
//# sourceMappingURL=Content.js.map